/* Строка списка со свайпом влево: под содержимым открывается красная зона удаления.
   Жест берём только когда палец пошёл вбок — вертикальное движение отдаём прокрутке. */

import React, { useRef, useState } from "react";

/** Ширина одной кнопки в зоне, которая открывается свайпом */
const ACTION_W = 88;
/** Пока палец не сдвинулся на столько — не решаем, свайп это или прокрутка */
const LOCK = 8;

export default function SwipeRow({
  children,
  onDelete,
  /** Необязательная вторая кнопка слева от удаления */
  onEdit,
  label = "Удалить",
  editLabel = "Изменить",
  /** Ручка перетаскивания и прочие «свои» области помечаются data-nodrag */
  className = "",
  contentClassName = "",
  style,
  ref,
}) {
  const [dx, setDx] = useState(0);
  const [swiping, setSwiping] = useState(false);
  const touch = useRef(null);
  const width = onEdit ? ACTION_W * 2 : ACTION_W;

  const onPointerDown = (e) => {
    if (e.target.closest?.("[data-nodrag]")) return;
    touch.current = { x: e.clientX, y: e.clientY, from: dx, axis: null };
  };

  const onPointerMove = (e) => {
    const t = touch.current;
    if (!t) return;
    const mx = e.clientX - t.x;
    const my = e.clientY - t.y;
    if (!t.axis) {
      if (Math.abs(mx) < LOCK && Math.abs(my) < LOCK) return;
      t.axis = Math.abs(mx) > Math.abs(my) ? "x" : "y";
      if (t.axis === "y") { touch.current = null; return; }
      setSwiping(true);
    }
    setDx(Math.max(-width, Math.min(0, t.from + mx)));
  };

  const onPointerUp = () => {
    if (!touch.current) return;
    touch.current = null;
    setSwiping(false);
    setDx((d) => (d < -width / 2 ? -width : 0));
  };

  // Действий нет (доступ только на чтение) — строка обычная, без жеста и кнопок
  if (!onDelete && !onEdit) {
    return (
      <li ref={ref} className={`relative overflow-hidden list-none ${className}`} style={style}>
        <div className={`relative ${contentClassName}`} style={{ background: "var(--tg-section-bg)" }}>
          {children}
        </div>
      </li>
    );
  }

  // list-none обязателен: вне ul браузер рисует у li чёрный буллет поверх содержимого
  return (
    <li ref={ref} className={`relative overflow-hidden list-none ${className}`} style={style}>
      <div className="absolute inset-y-0 right-0 flex" style={{ width }}>
        {onEdit ? (
          <button
            type="button"
            data-nodrag
            onClick={() => { setDx(0); onEdit(); }}
            className="flex items-center justify-center text-[15px] font-medium text-white"
            style={{ width: ACTION_W, background: "var(--tg-button)" }}
          >
            {editLabel}
          </button>
        ) : null}
        <button
          type="button"
          data-nodrag
          onClick={() => { setDx(0); onDelete(); }}
          className="flex items-center justify-center text-[15px] font-medium text-white"
          style={{ width: ACTION_W, background: "var(--fin-red)" }}
        >
          {label}
        </button>
      </div>

      <div
        className={`relative ${contentClassName}`}
        style={{
          transform: `translateX(${dx}px)`,
          transition: swiping ? "none" : "transform 0.2s",
          background: "var(--tg-section-bg)",
        }}
        onPointerDown={onPointerDown}
        onPointerMove={onPointerMove}
        onPointerUp={onPointerUp}
        onPointerCancel={onPointerUp}
      >
        {children}
      </div>
    </li>
  );
}
